import PropTypes from 'prop-types';
import React from 'react';
import UserCallToAction from '../../CallToAction/UserCallToAction/UserCallToAction';
import CommonCardShell from '../../Layout/CommonCardShell/CommonCardShell';
import LeftRailFooter from '../../Layout/Footer/LeftRailFooter/LeftRailFooter';
import CompaniesBox from '../../LeftRail/CompaniesBox/CompaniesBox';
import GroupsBox from '../../LeftRail/GroupsBox/GroupsBox';
import JobNotificationsBox from '../../LeftRail/JobNotificationsBox/JobNotificationsBox';
import './LeftRailContent.scss';
import { PAGE_DISPLAY_MODE } from '../../../pages/constants';
import { PageContext } from '../../../contexts/ContextCreator';

export default class LeftRailContent extends React.PureComponent {
    render() {
        const minimizedJobsLeftRail = this.props.minimizedJobsFlag;
        const { session } = this.context.pageProps;
        const { jobSearchView } = this.props;
        const isUser = session && Object.keys(session).length > 0;
        const hideProfileCard =
            !isUser && minimizedJobsLeftRail && jobSearchView;

        return (
            <div className="component-LeftRailLayout-LeftRailContent">
                <div className="desktop-display">
                    {!hideProfileCard && (
                        <CommonCardShell>
                            <UserCallToAction
                                jobSearchView={this.props.jobSearchView}
                                minimizedJobsFlag={this.props.minimizedJobsFlag}
                            />
                        </CommonCardShell>
                    )}
                    {this.context.pageDisplayMode ===
                        PAGE_DISPLAY_MODE.USER_DEFAULT && (
                        <React.Fragment>
                            {!minimizedJobsLeftRail && (
                                <CommonCardShell>
                                    <div className="Activities-Content">
                                        <GroupsBox
                                            {...this.context.joinedGroups}
                                        />
                                    </div>
                                </CommonCardShell>
                            )}
                            {!minimizedJobsLeftRail && (
                                <CommonCardShell>
                                    <div className="Activities-Content">
                                        <CompaniesBox
                                            {...this.context.followingCompanies}
                                            openModal={() =>
                                                this.context.modalTrigger(
                                                    'CompaniesModal'
                                                )
                                            }
                                        />
                                        <div className="silver-divider" />
                                        <JobNotificationsBox
                                            {...this.context.jobNotifications}
                                            openModal={() =>
                                                this.context.modalTrigger(
                                                    'FollowedJobs'
                                                )
                                            }
                                        />
                                    </div>
                                </CommonCardShell>
                            )}
                            {this.props.displayLeftRailFooter && (
                                <LeftRailFooter />
                            )}
                        </React.Fragment>
                    )}
                </div>
            </div>
        );
    }
}

LeftRailContent.contextType = PageContext;

LeftRailContent.propTypes = {
    /**
     * whether displaying or hidding left rail footer
     */
    displayLeftRailFooter: PropTypes.bool,
    /**
     * whether Profile CTA option is on if other checks pass.
     */
    allowProfileCTA: PropTypes.bool,
    profileLeftRailCTAMetrics: PropTypes.shape({
        LAT: PropTypes.string,
        LAC: PropTypes.string,
        clickMetric: PropTypes.string,
        impressionMetric: PropTypes.string,
    }),
    /**
     * whether current page is JobsSearchLanding
     */
    jobSearchView: PropTypes.bool,
    minimizedJobsFlag: PropTypes.bool,
};

LeftRailContent.defaultProps = {
    displayLeftRailFooter: false,
    allowProfileCTA: false,
    profileLeftRailCTAMetrics: {
        LAT: 'user-left-rail',
        LAC: 'user-left-rail',
        clickMetric: 'user-left-rail-profile-cta-click',
        impressionMetric: 'user-left-rail-profile-cta-impression',
    },
    jobSearchView: false,
    minimizedJobsFlag: false,
};
